import { useLocation, useNavigate } from 'react-router-dom'

import { Path } from 'constants/router'
import constate from 'constate'

export enum ProfileTab {
  SETTINGS = 'settings',
}

/** Context provider for profile navigation tabs */
export const [ProfileNavigationContextProvider, useProfileNavigation] = constate(() => {
  const navigate = useNavigate()
  const location = useLocation()

  // Derive active tab from URL pathname - single source of truth
  const activeTab = ProfileTab.SETTINGS

  const handleChangeTab = (selectedTab: ProfileTab) => {
    if (Object.values(ProfileTab).includes(selectedTab)) {
      navigate(Path.PROFILE_TAB.replace(':tab', selectedTab))
    }
  }

  return {
    handleChangeTab,
    activeTab,
  }
})
